import * as React from "react"

import { cn } from "./utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    // console.log({ className, type, ...props }, ref)
    let style = props?.style
    const display = style?.display !== undefined ? style.display : (props?.hidden === true ? "none" : "inherit")
    style = { ...style, display: display  }
    return (
        (<input
            type={type}
            className={cn(
                "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                className
            )}
            style={style}
            ref={ref}
            {...props} />)
    );
})
Input.displayName = "Input"

export { Input }
